module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    ref: "order",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-text', {
    staticClass: "text-sm-right"
  }, [_vm._v("\n          剩餘金幣："), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters.user.GoldCount))])])], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-toolbar', [_c('v-toolbar-title', [_vm._v("商品資訊")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.quantity))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.cost))])]
      }
    }]),
    model: {
      value: (_vm.cart),
      callback: function($$v) {
        _vm.cart = $$v
      },
      expression: "cart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3 mr-4"
  }, [_vm._v("\n                  預計扣除金幣: "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.total))])])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.cart[0].isDigital) ? _c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-toolbar', [_c('v-toolbar-title', [_vm._v("寄送資訊")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("姓名")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-1",
      "label": "姓名",
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.userinfo.Name),
      callback: function($$v) {
        _vm.$set(_vm.userinfo, "Name", $$v)
      },
      expression: "userinfo.Name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("聯絡地址")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-group",
    attrs: {
      "name": "input-2",
      "label": "聯絡地址",
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.userinfo.Address),
      callback: function($$v) {
        _vm.$set(_vm.userinfo, "Address", $$v)
      },
      expression: "userinfo.Address"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("聯絡電話")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-group",
    attrs: {
      "name": "input-3",
      "label": "聯絡電話",
      "value": "",
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.userinfo.Phone),
      callback: function($$v) {
        _vm.$set(_vm.userinfo, "Phone", $$v)
      },
      expression: "userinfo.Phone"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("配送時間")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": [{
        text: '無',
        value: 'None'
      }, {
        text: '早上',
        value: 'Morning'
      }, {
        text: '下午',
        value: 'Afternoon'
      }, {
        text: '晚上',
        value: 'Night'
      }],
      "label": "配送時間",
      "light": "",
      "single-line": "",
      "auto": ""
    },
    model: {
      value: (_vm.userinfo.SpecifiedTime),
      callback: function($$v) {
        _vm.$set(_vm.userinfo, "SpecifiedTime", $$v)
      },
      expression: "userinfo.SpecifiedTime"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "actions": ""
    }
  }, [_c('v-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "primary": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmPurchase()
      }
    }
  }, [_vm._v("兌換")])], 1)], 1), _vm._v(" "), (_vm.cart[0]) ? _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.confirm.purchase),
      callback: function($$v) {
        _vm.$set(_vm.confirm, "purchase", $$v)
      },
      expression: "confirm.purchase"
    }
  }, [_c('v-card', [_c('v-card-row', [_c('v-card-text', [_vm._v("確定要兌換 " + _vm._s(_vm.cart[0].name) + " ?")])], 1), _vm._v(" "), _c('v-card-row', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirm.purchase = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.purchase()
      }
    }
  }, [_vm._v("同意")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fdfff7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
// module id = 630
// module chunks = 1